<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-8">
          <h1 id="proy-code" class="pull-left">Formulario Partes Diarios</h1>
        </div>
        <div class="col-xs-4">
          <button class="btn btn-app pull-right bg-red" v-if="puedoEditar()" @click="crear()">
            <i class="fa fa-plus"></i> Nuevo
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 form-group" v-if="!codigo_proyecto">
          <select class="form-control" v-model="filtros.codigo_proyecto" @change="filtrarDatos(1)">
            <option :value="null">-- Seleccione --</option>
            <option v-for="proyecto in $store.state.apiData.proyectos" :value="proyecto.codigo_proyecto">{{ proyecto.codigo_proyecto }}</option>
          </select>          
        </div>        
        <!--div class="col-md-6 form-group">
          <div class="input-group">
            <input type="text" name="search" v-model="filtros.buscar" class="form-control" placeholder="Buscar..." :disabled="!$store.state.online">
            <div class="input-group-btn">
              <button type="button" class="btn btn-default" @click="filtrarDatos(1)" :disabled="!$store.state.online">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div-->
      </div>

      <div class="row">
          <div class="col-md-12 tab-container">
              <div class="nav-tabs-custom">
                  <ul class="nav nav-tabs pull-left">
                    <li class="active"><a href="#partes" data-toggle="tab" aria-expanded="true" @click="cambiarSolapa('partes')">Partes Diarios</a></li>
                    <li class=""><a href="#archivo" data-toggle="tab" aria-expanded="false" @click="cambiarSolapa('archivo')">Archivo</a></li>
                  </ul>
                  <div class="tab-content">
                      <div class="tab-pane active" id="partes">
                        <div class="clearfix"></div>
                        <tabla-parte-diario v-if="tabla_partes.mostrar" :solapa="'partes'" :data="partes" :total="tabla_partes.total" :regPagina="filtros._limit" :paginaActual="tabla_partes.pagina" @partes:filtar="filtrarDatos" @partes:acciones="acciones" :puedoEditar="puedoEditar()" :cargando="tabla_partes.cargando"></tabla-parte-diario>
                      </div>
                      <div class="tab-pane" id="archivo">
                        <div class="clearfix"></div>
                        <tabla-parte-diario v-if="tabla_archivo.mostrar" :solapa="'archivo'" :data="archivados" :total="tabla_archivo.total" :regPagina="filtros._limit" :paginaActual="tabla_archivo.pagina" @partes:filtar="filtrarDatos" @partes:acciones="acciones" :puedoEditar="puedoEditar()" :cargando="tabla_archivo.cargando"></tabla-parte-diario>
                      </div>
                      <!-- /.tab-pane -->
                    </div>
                </div>
                <!-- /.tab-content -->
            </div>        
      </div>
    </div>
    <a-m-parte-diario :mostrar="vistaAM.mostrar" :item="vistaAM.item" :atributosForm="atributosForm" :editar="vistaAM.accion !== 'ver'" @am-partes:cerrar="onCerrarVistaAM"></a-m-parte-diario>
  </div>
</template>
<script>
import api from '../../../api'
import {toQueryString} from '../../../filters/object'
import AMParteDiario from './AMParteDiario'
import TablaParteDiario from './TablaParteDiario'
import db from '../../../core/pouchdb'
import _ from 'lodash'
import { EventBus } from '../../../core/event-bus.js'
import moment from 'moment'
require('moment/locale/es')

export default {
  name: 'PartesDiarios',
  components: {
    AMParteDiario,
    TablaParteDiario
  },
  filters: {
    toQueryString
  },
  props: {
    codigo_proyecto: {
      type: String,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      vistaAM: {
        mostrar: false,
        item: null,
        accion: 'crear'
      },
      tabla_partes: {
        data: [],
        total: 0,
        pagina: 1,
        mostrar: true,
        index_item_actual: -1,
        cargando: true
      },
      tabla_archivo: {
        data: [],
        total: 0,
        pagina: 1,
        mostrar: false,
        index_item_actual: -1,
        cargando: false
      },
      atributosForm: null,
      modeloForm: {},
      solapaActual: 'partes',
      filtros: {
        codigo_proyecto: this.codigo_proyecto,
        _sort: 'fecha:desc',
        _limit: 50,
        buscar: ''
      },
      errores: null,
      loading: true,
      rolesEditar: ['root', 'manager', 'jefe_de_obras', 'coordinador', 'empleado', 'supervisor']
    }
  },
  computed: {
    archivados: function () {
      let _filtros = { archivado: true }
      return _.orderBy(_.filter(this.tabla_archivo.data, _filtros), 'fecha', 'desc')
    },
    partes: function () {
      let _filtros = { archivado: false }
      return _.orderBy(_.filter(this.tabla_partes.data, _filtros), 'fecha', 'desc')
    }
  },
  mounted () {
    let vm = this
    api.getModeloParteDiario().then(data => {
      vm.atributosForm = data.attributes
      vm.modeloForm = {}
      vm.atributosForm.forEach(attr => {
        vm.modeloForm[attr.name] = attr.params.default
      })
      vm.tabla_partes.mostrar = true
      vm.tabla_archivo.mostrar = true
      vm.getListado(this.solapaActual)
    }, error => {
      vm.tabla_partes.cargando = false
      vm.$store.commit('SHOW_DANGER_ALERT', {
        message: error.message
      })
    })

    EventBus.$on('sync-completed', () => {
      vm.filtrarDatos(1)
    })
  },
  destroyed () {
    EventBus.$off('sync-completed')
  },
  methods: {
    filtrarDatos (pagina, solapa) {
      let vm = this
      let _solapa = solapa || this.solapaActual

      if (solapa) {
        vm['tabla_' + solapa].pagina = pagina
      } else {
        vm.tabla_partes.pagina = pagina
        vm.tabla_archivo.pagina = pagina
      }

      vm.getListado(_solapa)
    },
    getListado (solapa) {
      let vm = this
      let filtrosBuscar = {}

      if (vm.filtros.buscar) {
        filtrosBuscar.observaciones_descripcion_contains = vm.filtros.buscar
      }

      if (solapa === 'archivo') {
        filtrosBuscar.archivado = true
      } else {
        filtrosBuscar.archivado = false
      }

      filtrosBuscar._start = (vm['tabla_' + solapa].pagina - 1) * this.filtros._limit

      let _filtros = Object.assign({}, vm.filtros, filtrosBuscar)
      delete _filtros.buscar

      vm['tabla_' + solapa].cargando = true
      api.getPartesDiarios(this.$options.filters.toQueryString(_filtros)).then(resp => {
        vm.dataActualizada(resp.data, solapa).then(data => {
          vm['tabla_' + solapa].data = data
          vm['tabla_' + solapa].total = resp.total
          vm['tabla_' + solapa].cargando = false
        })
      }, error => {
        vm.dataActualizada([], solapa).then(data => {
          vm['tabla_' + solapa].data = data
          vm['tabla_' + solapa].total = data.length
          vm['tabla_' + solapa].cargando = false
        })
        vm.errores = error.message
      })
    },
    dataActualizada (data, solapa) {
      let vm = this
      let _pagina = vm['tabla_' + solapa].pagina

      if (!this.$store.state.online) {
        return vm.combinarDataApiLocalID(data).then((resData) => {
          if (solapa === 'partes') {
            if (_pagina === 1) {
              return db.findByFilters('parte_diario', {action: 'create', codigo_proyecto: vm.filtros.codigo_proyecto}).then(dbData => {
                return _.unionBy(dbData.docs, resData)
              })
            }
          } else {
            if (_pagina === 1) {
              return db.findByFilters('parte_diario', {archivado: true, codigo_proyecto: vm.filtros.codigo_proyecto}).then(dbData => {
                return _.unionBy(dbData.docs, resData)
              })
            }
          }
          return Promise.resolve(resData)
        })
      } else {
        return Promise.resolve(data)
      }
    },
    combinarDataApiLocalID (dataApi) {
      let _ids = []
      for (let i = 0; i < dataApi.length; i++) {
        _ids.push(dataApi[i].id)
      }
      if (_ids.length > 0) {
        return db.findByIds(_ids, 'parte_diario').then(dbData => {
          return _.unionBy(dbData.docs, dataApi, 'id')
        })
      } else {
        return Promise.resolve(dataApi)
      }
    },
    cambiarSolapa (solapa) {
      this.solapaActual = solapa
      this.getListado(solapa)
    },
    puedoEditar () {
      return this.rolesEditar.indexOf(this.$store.state.user.role.type) > -1
    },
    crear () {
      this.vistaAM.item = _.assign({}, this.modeloForm, {
        codigo_proyecto: this.codigo_proyecto,
        cantidad_empleados: 0,
        usuario: this.$store.state.user.username,
        fecha: moment().format('YYYY-MM-DD') + 'T00:00:00.000',
        archivado: false
      })
      this.vistaAM.accion = 'crear'
      this.vistaAM.mostrar = true
    },
    editar (item, index) {
      this['tabla_' + this.solapaActual].index_item_actual = index
      this.vistaAM.item = _.cloneDeep(item)
      this.vistaAM.item.fecha = this.vistaAM.item.fecha.replace('Z', '')
      this.vistaAM.accion = 'editar'
      this.vistaAM.mostrar = true
    },
    ver (item) {
      this.vistaAM.item = _.cloneDeep(item)
      this.vistaAM.item.fecha = this.vistaAM.item.fecha.replace('Z', '')
      this.vistaAM.accion = 'ver'
      this.vistaAM.mostrar = true
    },
    onCerrarVistaAM (data) {
      let vm = this

      vm.vistaAM.mostrar = false

      if (data) {
        vm.$store.commit('SHOW_SUCCESS_ALERT', {
          message: 'La operación finalizó con éxito'
        })

        if (vm.vistaAM.accion === 'editar') {
          let _index = vm['tabla_' + vm.solapaActual].index_item_actual
          vm.$set(vm['tabla_' + vm.solapaActual].data, _index, data)
        } else {
          vm.filtrarDatos(1, vm.solapaActual)
        }

        vm['tabla_' + vm.solapaActual].index_item_actual = -1
      }
    },
    archivar (item, value) {
      let vm = this
      let tabla = value ? 'partes' : 'archivo'

      vm['tabla_' + tabla].cargando = true
      item.archivado = value
      vm.archivando = true
      if (vm.$store.state.online) {
        api.savePartesDiarios(item).then(data => {
          vm.archivando = false
          vm['tabla_' + tabla].cargando = false
          vm.getListado(this.solapaActual)
        }, error => {
          vm.archivando = false
          vm['tabla_' + tabla].cargando = false
          vm.errores = error.message
        })
      } else {
        if (value) {
          db.save(item, 'parte_diario', 'edit').then(function (response) {
            item._rev = response.rev
            vm['tabla_' + tabla].cargando = false
            vm.archivando = false
            vm.getListado(vm.solapaActual)
          }).catch(function (error) {
            vm.archivando = false
            vm['tabla_' + tabla].cargando = false
            vm.errores = error.message
            console.debug(error)
          })
        } else {
          vm['tabla_' + tabla].cargando = false
          alert('Para desarchivar el registro, debe estar online')
        }
      }
    },
    acciones (accion, item, index) {
      let vm = this
      switch (accion) {
        case 'ver':
          vm.ver(item)
          break
        case 'editar':
          vm.editar(item, index)
          break
        case 'archivar':
          vm.archivar(item, true)
          break
        case 'desarchivar':
          vm.archivar(item, false)
          break
      }
    }
  }
}
</script>
<style scoped>
  h1#proy-code {
    margin-top: 0;
  }
  .tab-container{
    padding-top: 20px
  }
</style>


// WEBPACK FOOTER //
// src/components/views/partes-diarios/index.vue